<template>
    <div class="page">
        
        <div class="grid-container">
            <div class="grid margin-on-medium">
                <div class="cell large-4 medium-12 small-12">
                    <div>
                        <h2>Upload CV</h2>
                        <hr/>
                        <LinkedRecord :record="linkedSfRecord" v-if="linkedSfRecord" />
                        <hr v-if="linkedSfRecord" />
                        <div id="cv-upload" />
                        <InputUpload label="CV File" :allowedFileTypes="allowedFileTypes" :maxFiles="this.uploadMax" @fileSelected="resetUploadErrors" :collection="cvUploadForm.collections.cvFiles" :maxFileSize="maxFileSize"/>
                        
                        <div class="api-error" v-for="error in uploadErrors" :key="error.filename">
                            {{error.filename}} : {{error.responseStatus.message}}
                        </div>

                        <InputSelect label="Brand" :field="cvUploadForm.fields.brand" :options="brands" :disabled="externalId != null" />
                        <InputSelect label="Cv Source" :field="cvUploadForm.fields.source" :options="cvSources"/>

                        <div class="button-container">
                            <a href="#" id="upload-button" class="button" @click.prevent="uploadCv"
                               :class="{disabled:isOccupied}">Upload</a>
                            <div class="error"></div>
                        </div>
                        <hr/>
                        <div class="info-text">
                            <div>Mandatory Steps</div>
                            <ul>
                                <li>Only upload CVs from the _FileUploads folder located on your desktop</li>
                                <li>Attach evidence of consent to the candidate record if required</li>
                                <li>Delete local copies of CVs once upload complete</li>
                            </ul>
                        </div>
                    </div>


                </div>
                <div class="cell large-8 medium-12 small-12">
                    <div id="staged-candidates">
                        <h2>CVs to review</h2>

                        <div id="staged-candidates-table-wrapper" v-if="stagedCandidatesList.length > 0" :class="{loading : fetchingScList}">
                            <Spinner />
                            <table id="staged-candidates-table">
                                <caption class="hidden">First column displays the status of each staged candidate. The last two colunms contain edit and delete actions respectively.</caption>
                                <thead>
                                    <th scope="col">Status</th>
                                    <th scope="col">Uploaded At</th>
                                    <th scope="col">Forename</th>
                                    <th scope="col">Surname</th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                </thead>
                                <tbody>
                                <tr v-for="(value, index) in stagedCandidatesList" :key="index" :class="{'new-candidate' : value.new}">
                                    <td>
                                        <SvgDot fill="#2CB725" title="Ready to Commit" v-if="value.isValid"/>
                                        <SvgDotHollow fill="#BF1F1F" title="Requires Review" v-else/>
                                        <SvgBriefcase fill="#FFF" title="Job Application" v-if="value.forJobId"/>
                                    </td>
                                    <td>{{value.uploadedAt | formatDateTimeLocal}}</td>
                                    <td>{{value.firstName || 'unknown'}}</td>
                                    <td>{{value.lastName || 'unknown'}}</td>
                                    <td class="text-right clickable" @click="selectUpload(value.id)"><div class="text-with-icon"><span>Edit</span><SvgEdit fill="#fff"/></div></td>
                                    <td class="text-right clickable" @click="deleteUpload(value.id)"><div class="text-with-icon"><span>Delete</span><SvgDelete fill="#fff"/></div></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="pagination" v-if="stagedCandidatesList.length > 0">
                            <div>
                                <a href="" class="back-cta cta-link" v-if="sclPrev" @click.prevent="prevPage">
                                    <div class="icon left"><SvgArrowLeft fill="primary"/></div>
                                    <span>Prev</span>
                                </a>
                            </div>
                            <div>
                                <a href="" class="back-cta cta-link" v-if="sclNext" @click.prevent="nextPage">
                                    <span>Next</span>
                                    <div class="icon right"><SvgArrowRight fill="primary"/></div>
                                </a>
                            </div>
                            
                        </div>
                        <div class="no-candidate-message" v-if="stagedCandidatesList.length == 0">
                            <p>You have no CVs to review. Please upload a CV to begin.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getStagedCandidateList, createStagedCandidate, deleteStagedCandidate, getSfCandidate} from "../../apis/sthree.consultant.api"

    import LinkedRecord from './LinkedRecord'
    import InputSelect from '../vue-components/src/components/core/inputs/InputSelect';
    import InputUpload from '../vue-components/src/components/core/inputs/upload/InputFileUpload';
    import CvUploadModel from '../../models/cvupload/CvUploadModel';
    /*import _ from 'lodash'
    import moment from 'moment'*/

    import Spinner from '../vue-components/src/components/core/icons/Spinner';
    import SvgArrowLeft from '../vue-components/src/components/core/icons/SvgArrowLeft';
    import SvgArrowRight from '../vue-components/src/components/core/icons/SvgArrowRight';
    import SvgDot from '../vue-components/src/components/core/icons//SvgDot';
    import SvgDotHollow from '../vue-components/src/components/core/icons/SvgDotHollow';
    import SvgBriefcase from '../vue-components/src/components/core/icons//SvgBriefcase';
    import SvgEdit from '../vue-components/src/components/core/icons//SvgEdit';
    import SvgDelete from '../vue-components/src/components/core/icons//SvgDelete';

    import cssVars from 'css-vars-ponyfill';

    export default {
        name: 'CvUpload',
        components: {InputSelect, InputUpload, LinkedRecord, Spinner, SvgArrowLeft, SvgArrowRight, SvgDot, SvgDotHollow, SvgBriefcase, SvgEdit, SvgDelete},
        async created() {
            this.resetCvUploadForm({});
            if (this.externalId){
                await getSfCandidate(this.externalId)
                    .then((val) => {
                        this.linkedSfRecord = val;
                        this.cvUploadForm.fields.brand.value = this.linkedSfRecord.brand;
                        this.cvUploadForm.fields.brand.initialValue = this.linkedSfRecord.brand;
                    })
                    .catch((error) => {
                        this.$store.dispatch('openMessageBox', {
                            message: 'Unable to find Salesforce Candidate.',
                            code: (error.responseStatus ? error.responseStatus.message : error),
                            okayText: 'Reload without Candidate link',
                            okayFunction: () => {
                                const url = window.location.href.replace(/externalId=([^&]*)/g,"").replace(/\?\&/g,"?");
                                window.location.href = url;
                                this.$router.go();
                            }
                        });
                    });
            }
            await this.fetchStagedCandidates();
            cssVars();

            window.addEventListener('keydown', (e) => {
                if (e.key == 'ArrowLeft') {
                    this.prevPage();
                }
                if (e.key == 'ArrowRight') {
                    this.nextPage();
                }
            });

        },
        data() {
            return {
                fetchingScList: false,
                linkedSfRecord: null,
                stagedCandidatesList: [],
                sclTake: 20,
                sclPrev: false,
                sclNext: false,
                sclSkip: 0,
                newestStagedCandidateID: null,
                cvUploadForm: new CvUploadModel(),
                collection: [],
                uploadErrors: []
            };
        },
        computed: {
            allowedFileTypes() {
                return this.$store.state.cvUpload.allowedFileTypes;
            },
            maxFileSize() {
                return process.env.VUE_APP_CV_FILE_MAX_SIZE_BYTES;
            },
            isOccupied() {
                return this.$store.state.activity.fetching || this.$store.state.activity.uploading
            },
            cvSources() {
                return this.$store.state.app.lookup['CvSources'] || [];
            },
            brands() {
                return this.$store.state.app.lookup['Brand'] || [];
            },
            externalId() {
                return this.$route.query.externalId != '' ? this.$route.query.externalId : null;
            },
            uploadMax() {
                if (this.externalId) {
                    return 1;
                } else {
                    return process.env.VUE_APP_CV_MAX_UPLOAD_FILES;
                }
            },
            candidateCount() {
                return stagedCandidatesList.length;
            }
        },
        methods: {
            resetUploadErrors(){
                this.uploadErrors = [];
            },
            resetCvUploadForm({brand, source}){
                this.cvUploadForm = new CvUploadModel({
                    uploadedById: this.$store.state.user.id,
                    externalId: this.externalId,
                    brand: brand,
                    source: source
                });

                if(this.externalId){
                    //If salesforce candidate is already specified, brand should not be required
                    this.cvUploadForm.fields.brand.validation.required = false
                }
            },
            filesSelectedHandler(fileCollection) {
                if(fileCollection.length) {
                    this.cvUploadForm.fields.file.value = true
                } else {
                    this.cvUploadForm.fields.file.value = null
                }

                fileCollection.forEach((file, index) => {
                    this.collection.splice(index, 1, file);
                });
            },
            selectUpload(id) {
                this.$router.push({
                    path: (this.$route.path.substr(-1) === '/' ?  this.$route.path + id : this.$route.path + '/' + id) + (this.externalId ? '?externalId=' + this.externalId : ''),
                    query: {
                        contact: this.$route.query.contact
                    }
                });
            },
            deleteUpload(id) {
                const idToDelete = id;
                const self = this;
                this.$store.dispatch('openMessageBox', {
                    message: 'Are you sure you wish to permanently delete this CV?',
                    okayText: 'Delete CV',
                    okayFunction: () => {
                        self.$store.dispatch('startUpload');
                        deleteStagedCandidate(idToDelete)
                            .then(() => {
                                self.$store.dispatch('endUpload');
                                self.fetchStagedCandidates()
                                .then(() => {
                                    self.$store.dispatch('alert', 'CV deleted.');
                                });

                            })
                            .catch((error) => {
                                self.$store.dispatch('endUpload');
                                self.$store.dispatch('openMessageBox', {
                                    message: 'Unable to delete Candidate.',
                                    code: (error.responseStatus ? error.responseStatus.message : error),
                                    okayText: 'Continue',
                                    okayFunction: () => {
                                    }
                                });
                            });
                    },
                    confirmBox: true
                });
            },
            async fetchStagedCandidates(skip) {
                window.scrollTo(0,0);
                this.fetchingScList = true;
                
                return getStagedCandidateList(this.$store.state.user.id, this.externalId, this.sclTake, skip)
                    .then((value) => {
                        this.stagedCandidatesList = value.candidates.filter(x => Number.isInteger(x.id));
                        this.sclSkip = value.skip;
                        this.sclPrev = value.hasPrev;
                        this.sclNext = value.hasNext;
                        this.fetchingScList = false;
                    })
                    .catch((error) => {
                        this.fetchingScList = false;
                        if (error.responseStatus) {
                            this.$store.dispatch('throwErrorFatal', error.responseStatus.message);
                        } else {
                            this.$store.dispatch('throwErrorFatal', error);
                        }
                    });
            },
            nextPage() {
                if(this.sclNext){
                    this.fetchStagedCandidates(this.sclSkip + this.sclTake);
                }
            },
            prevPage() {
                if(this.sclPrev){
                    this.fetchStagedCandidates(this.sclSkip - this.sclTake);
                }
            },
            async uploadCv() {
                this.uploadErrors = [];
                this.cvUploadForm.validate();
                if(this.cvUploadForm.valid) {
                    window.scrollTo(0,0);
                    this.$store.dispatch('startUpload');
                    const form = this.cvUploadForm.values();
                    let fileCollection = this.cvUploadForm.collections.cvFiles.value;
                    for(let i = 0; i < fileCollection.length; i++) {
                        if(fileCollection.length > 1){
                            this.$store.commit('setProcessingMsg', `Processing file ${i+1} of ${fileCollection.length}`);
                        }
                        fileCollection[i].validate();
                        if(fileCollection[i].valid){
                            const toSend = Object.assign({}, form, fileCollection[i].values());
                            await createStagedCandidate(toSend)
                                .then((value) => {
                                    this.newestStagedCandidateID = value.id;
                                })
                                .catch((error) => {
                                    error['filename'] = fileCollection[i].fields.name.value;
                                    this.uploadErrors.push(error);
                                });
                            const oldModel = this.cvUploadForm;
                            this.resetCvUploadForm({brand: oldModel.fields.brand.value, source: oldModel.fields.source.value});
                        }
                    }

                    this.$store.dispatch('endUpload');

                    if(this.externalId && fileCollection.length === 1){
                        this.selectUpload(this.newestStagedCandidateID);
                    } else {
                        this.fetchStagedCandidates().then(() => {
                            if (this.uploadErrors.length === 0) {
                                this.$store.dispatch('alert', 'CV ready to review.');
                            } else if (fileCollection.length === 1) {
                                this.$store.dispatch('alertError', 'CV could not be uploaded.');
                            } else if (fileCollection.length > this.uploadErrors.length) {
                                this.$store.dispatch('alertError', 'Some CVs could not be uploaded.');
                            }else {
                                this.$store.dispatch('alertError', 'CVs could not be uploaded.');
                            }
                        });
                    }

                } else {
                    this.$store.dispatch('alert', 'Upload error occurred.');
                }  
            }
        }
    }
</script>

<style scoped>

    #cv-upload {margin-top: -.5rem;}
    #no-candidate-message {margin-top: -.5rem;}

    #staged-candidates-table-wrapper {overflow-x: auto; margin-top: 1.45rem; background-color: #cdcdcd;}
        #staged-candidates-table-wrapper >>> .spinner {position: absolute; font-size: .75rem; top: 0; right: 0; bottom: 0; left: 0; margin: auto; opacity: 0;}
        #staged-candidates-table-wrapper.loading >>> .spinner {opacity: 1;}
        
    #staged-candidates-table {opacity: 1; transition: .25s;}
    .loading #staged-candidates-table {opacity: 0;}

    #file {display: none}

    .api-error {padding: .2rem 0; font-size: .75rem; color: var(--colour-error); font-weight: 700; text-align: right;}

    table {min-width: 38rem;}
    tr.ready {background-color: #3f9c16;}
    table >>> .svg {width: 1.5rem; height: 1.5rem; display: inline-block;}

    .pagination {margin-top: .5rem; display: flex; justify-content: space-between;}

    .file-selected { color: #3F9C16; }
    .new-candidate { background-color: #D39B46; }

</style>